module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("reasontype", [_c('p', {
    staticClass: "radio-group"
  }, [_vm._v("推荐关键词筛选："), _c('v-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reason.currentReason),
      expression: "reason.currentReason"
    }],
    attrs: {
      "name": 'reason',
      "options": _vm.reason.reasonList
    },
    domProps: {
      "value": (_vm.reason.currentReason)
    },
    on: {
      "input": function($event) {
        _vm.reason.currentReason = $event
      }
    }
  })], 1), _c('span', {
    staticClass: "floatr advice-tip"
  }, [_vm._v("采纳以下"), _c('i', {
    staticClass: "red"
  }, [_vm._v(" " + _vm._s(_vm.adviceSuggestNum) + " ")]), _vm._v("个建议预计展现量提升 "), _c('i', {
    staticClass: "red"
  }, [_vm._v(_vm._s(_vm.adviceEstiAddAdpv) + " ")])])], {
    reason: _vm.reason
  }), _c('div', {
    staticClass: "advice-table"
  }, [_c('HeadFixedTable', {
    attrs: {
      "columns": _vm.currentColumns,
      "checkbox": _vm.hasCheckbox,
      "check_all": _vm.hasCheckbox,
      "checkbox_length": 1000,
      "isAllChecked": _vm.isAllChecked,
      "list": _vm.currentList,
      "hasPagination": true
    },
    on: {
      "pageChange": _vm.pageChange
    },
    scopedSlots: {
      "planId-td": function(props) {
        return [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!props.item.planEdit),
            expression: "!props.item.planEdit"
          }]
        }, [_c('span', {
          attrs: {
            "title": props.item.submit_plan
          }
        }, [_vm._v(_vm._s(_vm._f("planGroupName")(props.item.submit_plan)) + " ")]), _c('span', [_vm._v("-")]), _c('span', {
          attrs: {
            "title": props.item.submit_plan
          }
        }, [_vm._v(" " + _vm._s(_vm._f("planGroupName")(props.item.submit_groupName)))])]), _c('span', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.stop($event)
            }
          }
        }, [(props.item.planEdit) ? _c('Casecade', {
          ref: "plangroup",
          attrs: {
            "selected": props.item.submit_planId + '',
            "subSelected": props.item.submit_groupId + '',
            "options": _vm.planList,
            "subOptions": _vm.groupList
          },
          on: {
            "search": _vm.getSearchPlanList,
            "subsearch": _vm.subSearch,
            "change": _vm.savePlanGroup
          }
        }) : _vm._e()], 1), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.isItemEditable(props.item)),
            expression: "isItemEditable(props.item)"
          }],
          staticClass: "btn btn-icon",
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.openPlanGroup(props.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-edit"
        })])]
      },
      "bidtype-td": function(props) {
        return [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!props.item.bidtypeEdit),
            expression: "!props.item.bidtypeEdit"
          }]
        }, [_vm._v(_vm._s(_vm._f("bidtypeFilter")(props.item)))]), _c('span', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.stop($event)
            }
          }
        }, [_c('v-select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (props.item.submit_bidtype),
            expression: "props.item.submit_bidtype"
          }, {
            name: "show",
            rawName: "v-show",
            value: (props.item.bidtypeEdit),
            expression: "props.item.bidtypeEdit"
          }],
          ref: "bidtype",
          attrs: {
            "options": _vm.bidtypes
          },
          domProps: {
            "value": (props.item.submit_bidtype)
          },
          on: {
            "input": [function($event) {
              props.item.submit_bidtype = $event
            }, function($event) {
              _vm.saveBidtype(props.item)
            }]
          }
        })], 1), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.isItemEditable(props.item)),
            expression: "isItemEditable(props.item)"
          }],
          staticClass: "btn btn-icon",
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.openBidtype(props.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-edit"
        })])]
      },
      "rec_price-td": function(props) {
        return [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!props.item.priceEdit),
            expression: "!props.item.priceEdit"
          }]
        }, [_vm._v(_vm._s(props.item.submit_price))]), (props.item.priceEdit) ? _c('span', {
          staticStyle: {
            "position": "relative"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.stop($event)
            }
          }
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (props.item.submit_price),
            expression: "props.item.submit_price"
          }],
          ref: "price",
          staticClass: "size-small",
          class: {
            'error': _vm.isPriceUnvalid(props.item)
          },
          attrs: {
            "type": "text",
            "placeholder": '最多保留两位小数'
          },
          domProps: {
            "value": _vm._s(props.item.submit_price)
          },
          on: {
            "keyup": function($event) {
              if (_vm._k($event.keyCode, "enter", 13)) { return; }
              _vm.saveprice(props.item)
            },
            "input": function($event) {
              if ($event.target.composing) { return; }
              props.item.submit_price = $event.target.value
            }
          }
        }), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (props.item.lowpriceshow && _vm.advicePriceWarning != ''),
            expression: "props.item.lowpriceshow && advicePriceWarning != ''"
          }],
          staticClass: "warning-tip"
        }, [_vm._v(_vm._s(_vm.advicePriceWarning)), _c('i', {
          staticClass: "fa fa-times",
          on: {
            "click": function($event) {
              $event.stopPropagation();
              props.item.lowpriceshow = false
            }
          }
        })])]) : _vm._e(), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.isItemEditable(props.item)),
            expression: "isItemEditable(props.item)"
          }],
          staticClass: "btn btn-icon",
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.openPriceEdit(props.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-edit"
        })])]
      },
      "delete-td": function(props) {
        return [_vm._t("delete", null, {
          item: props.item
        })]
      },
      "status-td": function(props) {
        return [_vm._t("status", null, {
          item: props.item
        })]
      }
    }
  }, [_c('v-tooltip', {
    attrs: {
      "tip": '为您推荐同类账户中该关键词设置的匹配模式',
      "pos": "left"
    },
    slot: "bidtype"
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    staticStyle: {
      "margin-left": "5px"
    }
  })]), _c('v-tooltip', {
    attrs: {
      "tip": '结合出价目标和同类客户对该词的出价意愿为您推荐出价建议，出价不得低于0.3元',
      "pos": "left"
    },
    slot: "rec_price"
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    staticStyle: {
      "margin-left": "5px"
    }
  })])], 1)], 1)], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c01e2396", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c01e2396!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pageview/web/kr_advice_table.vue
// module id = 794
// module chunks = 0